<header class="main-header">
  <div class="main-header__branding-container">
    <div class="main-header__branding"></div>
  </div>
</header>
